import { render, staticRenderFns } from "./DesktopCustomControl.vue?vue&type=template&id=5c2e4926&scoped=true"
import script from "./DesktopCustomControl.vue?vue&type=script&lang=ts"
export * from "./DesktopCustomControl.vue?vue&type=script&lang=ts"
import style0 from "./DesktopCustomControl.vue?vue&type=style&index=0&id=5c2e4926&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2e4926",
  null
  
)

export default component.exports